import { FormValues } from "@/types/loan";
import { 
  validateEmail, 
  sanitizeString,
  sanitizeEmail,
  sanitizePhoneNumber,
  validateSession,
  initializeSession
} from "@/utils/security";
import { ClientEncryption } from "@/utils/encryption";

export const loadApplicationData = (): FormValues | null => {
  try {
    if (!validateSession()) {
      ClientEncryption.removeSecureItem('savedApplicationData');
      return null;
    }
    
    const savedData = ClientEncryption.getSecureItem('savedApplicationData');
    if (savedData) {
      // Validate loaded data
      if (savedData.email && !validateEmail(savedData.email)) {
        ClientEncryption.removeSecureItem('savedApplicationData');
        return null;
      }
      
      return savedData;
    }
  } catch (error) {
    console.error('Error loading saved application data:', error);
    ClientEncryption.removeSecureItem('savedApplicationData');
  }
  return null;
};

export const saveApplicationData = (data: FormValues): void => {
  try {
    if (!validateSession()) {
      initializeSession();
    }
    
    // Sanitize data before saving
    const sanitizedData = {
      ...data,
      firstName: sanitizeString(data.firstName || ''),
      lastName: sanitizeString(data.lastName || ''),
      email: sanitizeEmail(data.email || ''),
      phoneNumber: sanitizePhoneNumber(data.phoneNumber || '')
    };
    
    ClientEncryption.setSecureItem('savedApplicationData', sanitizedData);
  } catch (error) {
    console.error('Error saving application data:', error);
  }
};